/**
 * 处理route路由配置文件
 */
import {constantRoutesConfig, asyncRoutesConfig} from './config';
// 通用路由
let constantRoutes = [];
// 有关权限路由
let asyncRoutes = [];


// 无权限路由配置
constantRoutesConfig.forEach(nav => {
  let route = instance(nav)
  constantRoutes.push(route)
})

// 有权限路由配置
asyncRoutesConfig.forEach(nav => {
  let route = instance(nav, true)
  asyncRoutes.push(route)
})
/**
 * 处理路由配置项
 * @param {} conf 配置项
 * requireAuth 是否有权限，是否要走登录
 */
function instance (conf, requireAuth = false) {
  let component = null
  let meta = {requireAuth}
  if (conf.component) {
    component = resolve => require(['../' + conf.component], resolve)
  }
  if (conf.meta) {
    meta = {...conf.meta, ...meta}
  }
  let route = {...conf, component, meta}
  if (conf.children && conf.children instanceof Array) {
    route.children = []
    for (let child of conf.children) {
      let childRoute = instance(child, requireAuth)
      if (typeof childRoute !== 'undefined') {
        route.children.push(childRoute)
      }
    }
  }
  return route
}


export {
  constantRoutes,
  asyncRoutes
}



// WEBPACK FOOTER //
// ./src/router/instance.js